export const download = (filename, data, isURL = false) => {
	const element = document.createElement('a');
	element.setAttribute('href', isURL ? data : 'data:text/csv;charset=utf-8,' + encodeURIComponent(data));
	element.setAttribute('download', filename);

	element.style.display = 'none';
	document.body.appendChild(element);

	element.click();

	document.body.removeChild(element);
};
